import { collection, onSnapshot, query, where } from 'firebase/firestore';

function mergeApprovedInterestLabels(docs, { liveReportId } = {}) {
  const merged = [];
  const seen = new Set();

  docs.forEach((docSnap) => {
    const data = typeof docSnap.data === 'function' ? docSnap.data() : docSnap;
    const docReportId = data?.liveReportId || null;

    if (liveReportId !== undefined) {
      if (liveReportId === null && docReportId) return;
      if (liveReportId !== null && docReportId !== liveReportId) return;
    }

    const interests = Array.isArray(data?.interests) ? data.interests : [];
    interests.forEach((label) => {
      const trimmed = String(label || '').trim();
      const key = trimmed.toLowerCase();
      if (!trimmed || seen.has(key)) return;
      seen.add(key);
      merged.push(trimmed);
    });
  });

  return merged;
}

export function subscribeApprovedVenueInterestTagDocs(db, venueId, callback) {
  if (!venueId) {
    callback([]);
    return () => {};
  }

  const q = query(
    collection(db, 'venue_interest_tags'),
    where('venueId', '==', venueId),
    where('status', '==', 'approved')
  );

  return onSnapshot(
    q,
    (snap) => callback(snap.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))),
    () => callback([])
  );
}

export function subscribeApprovedVenueInterestLabels(db, venueId, callback) {
  return subscribeApprovedVenueInterestTagDocs(db, venueId, (docs) => {
    callback(mergeApprovedInterestLabels(docs));
  });
}

export function mergeApprovedVenueInterestLabels(docs, options) {
  return mergeApprovedInterestLabels(docs, options);
}
